import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import LanguageStrings from '../../../i18n/locales'

export interface gatewayDeleteState {
  isLoading: boolean
  error: string | undefined
  gatewayDeleteData: string | undefined
  httpStatus: number | undefined
}

export const initialState: gatewayDeleteState = {
  isLoading: true,
  error: undefined,
  gatewayDeleteData: undefined,
  httpStatus: 0
}

const GatewayManagementStrings =
  LanguageStrings().GatewayManagementCollectionStrings.TableComponent

const gatewayDeleteSlice = createSlice({
  name: 'gatewayDelete',
  initialState,
  reducers: {
    gatewayDeleteLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        gatewayDeleteData: undefined,
        httpStatus: 0
      }
    },
    gatewayDeleteUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        gatewayDeleteData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    gatewayDeleteErrorAction: (state, action: PayloadAction<{ errorMessage: string | undefined, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage ?? GatewayManagementStrings.NetworkError,
        gatewayDeleteData: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  gatewayDeleteLoadingAction,
  gatewayDeleteUpdateAction,
  gatewayDeleteErrorAction
} = gatewayDeleteSlice.actions

export default gatewayDeleteSlice.reducer
